// Timer Engine for Wage time tracking
// Manages count-up timer state, localStorage persistence, and tab sync
(function() {
  'use strict';

  var STORAGE_KEY = 'firmee_wage_timer';
  var intervalId = null;

  // --- State Management ---

  function loadState() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      if (data) return JSON.parse(data);
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
    }
    return null;
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      // localStorage disabled or full - timer works but won't persist
    }
  }

  function clearState() {
    localStorage.removeItem(STORAGE_KEY);
  }

  // --- Elapsed Time Calculation ---

  function getElapsedMs(state) {
    if (!state) return 0;
    if (state.status === 'idle') return 0;
    if (state.status === 'paused') return state.accumulatedMs || 0;
    if (state.status === 'running') {
      var now = Date.now();
      var resumed = new Date(state.resumedAt).getTime();
      return (state.accumulatedMs || 0) + (now - resumed);
    }
    return 0;
  }

  function formatTime(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function formatDatetime(date) {
    var y = date.getFullYear();
    var m = pad(date.getMonth() + 1);
    var d = pad(date.getDate());
    var h = pad(date.getHours());
    var min = pad(date.getMinutes());
    return y + '/' + m + '/' + d + ' ' + h + ':' + min;
  }

  // --- Timer Actions ---

  function startTimer(matterId, matterName) {
    var state = loadState();
    if (state && state.status !== 'idle') return false; // already running

    var now = new Date().toISOString();
    var newState = {
      status: 'running',
      matterId: matterId,
      matterName: matterName,
      startedAt: now,
      resumedAt: now,
      accumulatedMs: 0
    };
    saveState(newState);
    updateUI(newState);
    startInterval(newState);
    return true;
  }

  function pauseTimer() {
    var state = loadState();
    if (!state || state.status !== 'running') return;

    var now = Date.now();
    var resumed = new Date(state.resumedAt).getTime();
    state.accumulatedMs = (state.accumulatedMs || 0) + (now - resumed);
    state.resumedAt = null;
    state.status = 'paused';
    saveState(state);
    updateUI(state);
    stopInterval();
  }

  function resumeTimer() {
    var state = loadState();
    if (!state || state.status !== 'paused') return;

    state.status = 'running';
    state.resumedAt = new Date().toISOString();
    saveState(state);
    updateUI(state);
    startInterval(state);
  }

  function stopTimer() {
    var state = loadState();
    if (!state || state.status === 'idle') return;

    var elapsedMs = getElapsedMs(state);
    var durationHours = Math.round(elapsedMs / 3600000 * 100) / 100;
    var durationMinutes = Math.floor(elapsedMs / 60000);
    var startDate = new Date(state.startedAt);
    var endDate = new Date();
    var matterId = state.matterId;

    clearState();
    stopInterval();
    updateUI(null);

    // Redirect to wage creation form with pre-filled params
    var params = [
      'matter_id=' + encodeURIComponent(matterId),
      'start=' + encodeURIComponent(formatDatetime(startDate)),
      'end=' + encodeURIComponent(formatDatetime(endDate)),
      'duration=' + encodeURIComponent(durationHours),
      'duration_minutes=' + encodeURIComponent(durationMinutes)
    ];
    Turbo.visit('/wages/new?' + params.join('&'));
  }

  // --- UI Update ---

  function updateUI(state) {
    var widget = document.getElementById('wage-timer-widget');
    if (!widget) return;

    var display = document.getElementById('timer-display');
    var matterLabel = document.getElementById('timer-matter-name');
    var pauseBtn = document.getElementById('timer-pause-btn');
    var resumeBtn = document.getElementById('timer-resume-btn');
    var stopBtn = document.getElementById('timer-stop-btn');

    if (!state || state.status === 'idle') {
      widget.style.display = 'none';
      if (display) display.textContent = '00:00:00';
      return;
    }

    widget.style.display = 'block';

    if (matterLabel) {
      matterLabel.textContent = state.matterName || '';
    }

    if (display) {
      display.textContent = formatTime(getElapsedMs(state));
      display.classList.toggle('timer-blink', state.status === 'paused');
    }

    if (pauseBtn) pauseBtn.style.display = state.status === 'running' ? 'inline-block' : 'none';
    if (resumeBtn) resumeBtn.style.display = state.status === 'paused' ? 'inline-block' : 'none';
    if (stopBtn) stopBtn.style.display = 'inline-block';

    widget.classList.toggle('timer-paused', state.status === 'paused');

    // Update matter page start button state
    updateMatterButton(state);
  }

  function updateMatterButton(state) {
    var btns = document.querySelectorAll('#timer-start-btn, .timer-start-link');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var textNode = btn.querySelector('.timer-label-text') || btn;
      if (state && state.status !== 'idle') {
        textNode.textContent = '計測中';
        btn.classList.add('disabled');
      } else {
        textNode.textContent = 'タイマー開始';
        btn.classList.remove('disabled');
      }
    }
  }

  // --- Interval Management ---

  function startInterval(state) {
    stopInterval();
    var resumedAt = new Date(state.resumedAt).getTime();
    var base = state.accumulatedMs || 0;
    intervalId = setInterval(function() {
      var display = document.getElementById('timer-display');
      if (display) {
        display.textContent = formatTime(base + (Date.now() - resumedAt));
      }
    }, 1000);
  }

  function stopInterval() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  // --- Initialization ---

  function init() {
    var state = loadState();
    updateUI(state);

    if (state && state.status === 'running') {
      startInterval(state);
    }

    // Bind widget buttons only once (widget survives Turbo navigations)
    var widget = document.getElementById('wage-timer-widget');
    if (widget && !widget.dataset.timerBound) {
      widget.dataset.timerBound = '1';

      var pauseBtn = document.getElementById('timer-pause-btn');
      var resumeBtn = document.getElementById('timer-resume-btn');
      var stopBtn = document.getElementById('timer-stop-btn');

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          pauseTimer();
        });
      }
      if (resumeBtn) {
        resumeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          resumeTimer();
        });
      }
      if (stopBtn) {
        stopBtn.addEventListener('click', function(e) {
          e.preventDefault();
          stopTimer();
        });
      }
    }

    // Bind matter page start buttons (these are in page body, replaced by Turbo)
    var startBtns = document.querySelectorAll('#timer-start-btn, .timer-start-link');
    for (var i = 0; i < startBtns.length; i++) {
      (function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (btn.classList.contains('disabled')) return;
          var matterId = btn.getAttribute('data-matter-id');
          var matterName = btn.getAttribute('data-matter-name');
          if (matterId) {
            startTimer(parseInt(matterId, 10), matterName);
          }
        });
      })(startBtns[i]);
    }
  }

  // --- Tab Sync ---

  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) {
      var state = loadState();
      updateUI(state);
      stopInterval();
      if (state && state.status === 'running') {
        startInterval(state);
      }
    }
  });

  // --- Turbo Lifecycle ---

  document.addEventListener('turbo:load', function() {
    init();
  });

  document.addEventListener('turbo:before-visit', function() {
    stopInterval();
  });

  // Fallback for non-Turbo pages
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
